export default __webpack_public_path__ + "static/media/neildegrasse.0d21f227.png";